import React from "react";

const ProfessionalInquiriesPage = () => {
  return (
    <div className="col-span-12 -mt-3">
      <h4 className="text-xl md:text-2xl font-bold leading-[130%] md:leading-[180%] text-[#04091E]">
        Professional Inquiries Page
      </h4>
      <div className="flex items-center justify-center mt-5 text-lg text-primary bg-white py-6 font-bold">
        Coming Soon.
      </div>
    </div>
  );
};

export default ProfessionalInquiriesPage;
